module.exports = __webpack_public_path__ + "img/viber_back.6592d7fa.png";